import { render, staticRenderFns } from "./PastPaper.vue?vue&type=template&id=76ce631f&scoped=true&"
import script from "./PastPaper.vue?vue&type=script&lang=js&"
export * from "./PastPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ce631f",
  null
  
)

export default component.exports